export default __webpack_public_path__ + "static/media/Urgent 3.9c97fe02.svg";